"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiFilter = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const BaseFilter_1 = require("./BaseFilter");
const SelectFieldBase_1 = require("../../inputs/internal/SelectFieldBase");
const MultiSelectField_1 = require("../../inputs/MultiSelectField");
const ToggleChipGroup_1 = require("../../inputs/ToggleChipGroup");
const defaultTestId_1 = require("../../utils/defaultTestId");
function multiFilter(props) {
    return (key) => new MultiFilter(key, props);
}
exports.multiFilter = multiFilter;
class MultiFilter extends BaseFilter_1.BaseFilter {
    render(value, setValue, tid, inModal, vertical) {
        var _a;
        if (inModal && this.props.options.length > 0 && this.props.options.length <= 8) {
            const { disabledOptions } = this.props;
            const disabledOptionsWithReasons = Object.fromEntries((_a = disabledOptions === null || disabledOptions === void 0 ? void 0 : disabledOptions.map(SelectFieldBase_1.disabledOptionToKeyedTuple)) !== null && _a !== void 0 ? _a : []);
            const disabledKeys = Object.keys(disabledOptionsWithReasons);
            return ((0, jsx_runtime_1.jsx)(ToggleChipGroup_1.ToggleChipGroup, { label: this.label, options: this.props.options.map((o) => {
                    const value = this.props.getOptionValue(o);
                    const disabled = value && disabledKeys.includes(value.toString());
                    const disabledReason = disabled ? disabledOptionsWithReasons[value.toString()] : undefined;
                    return {
                        label: this.props.getOptionLabel(o),
                        value: value,
                        disabled: disabledReason !== null && disabledReason !== void 0 ? disabledReason : disabled,
                    };
                }), onChange: (values) => {
                    setValue(values.length === 0 ? undefined : values);
                }, values: value || [], hideLabel: true, ...tid[(0, defaultTestId_1.defaultTestId)(this.label)] }));
        }
        const { defaultValue, nothingSelectedText, ...props } = this.props;
        return ((0, jsx_runtime_1.jsx)(MultiSelectField_1.MultiSelectField, { ...props, compact: !vertical, label: this.label, values: value || [], labelStyle: inModal ? "hidden" : !inModal && !vertical ? "inline" : "above", sizeToContent: !inModal && !vertical, onSelect: (values) => {
                setValue(values.length === 0 ? undefined : values);
            }, nothingSelectedText: nothingSelectedText !== null && nothingSelectedText !== void 0 ? nothingSelectedText : "All", ...this.testId(tid) }));
    }
}
